import SplitterLayout from 'react-splitter-layout';
import styles from './Splitter.module.css';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

const Splitter = React.forwardRef((props, ref) => {
  const splitterRef = useRef();

  /** 외부에서 접근할 수 있는 함수들 */
  React.useImperativeHandle(ref, () => ({
    // 보조창 크기 set
    setSecondarySize(newSize) {
      if (newSize >= 0) {
        splitterRef.current.setState({
          // 픽셀 단위로 width 설정 시 값의 반으로 나누는 방법
          // secondaryPaneSize: splitterRef.current.container.offsetWidth / 2,
          secondaryPaneSize: newSize,
        });
      }
    },
    // 보조창 크기 get
    getSecondarySize() {
      return splitterRef.current.state.secondaryPaneSize;
    },
  }));

  const _onDragStart = () => {};

  const _onDragEnd = () => {};

  const _onSecondaryPaneSizeChange = (newSize) => {};

  return (
    <SplitterLayout
      ref={splitterRef}
      customClassName={styles.e3Splitter}
      vertical={props.vertical}
      percentage={props.percentage}
      primaryIndex={props.primaryIndex}
      primaryMinSize={props.primaryMinSize}
      secondaryMinSize={props.secondaryMinSize}
      {...(props.secondaryInitialSize >= 0 && { secondaryInitialSize: props.secondaryInitialSize })}
      onDragStart={_onDragStart}
      onDragEnd={_onDragEnd}
      onSecondaryPaneSizeChange={_onSecondaryPaneSizeChange}
    >
      {props.children}
    </SplitterLayout>
  );
});

const SplitterPropTypes = {
  vertical: PropTypes.bool,
  percentage: PropTypes.bool,
  primaryIndex: PropTypes.number,
  primaryMinSize: PropTypes.number,
  secondaryMinSize: PropTypes.number,
  secondaryInitialSize: PropTypes.number,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onSecondaryPaneSizeChange: PropTypes.func,
  children: PropTypes.node,
};
Splitter.propTypes = SplitterPropTypes;
Splitter.defaultProps = {
  vertical: false,
  percentage: true,
  primaryIndex: 0,
  primaryMinSize: 0,
  secondaryMinSize: 0,
  secondaryInitialSize: null,
  onDragStart: null,
  onDragEnd: null,
  onSecondaryPaneSizeChange: null,
};

export default Splitter;
